import { render } from "./CoprarConvert.vue?vue&type=template&id=6dececa8&scoped=true"
import script from "./CoprarConvert.vue?vue&type=script&lang=js"
export * from "./CoprarConvert.vue?vue&type=script&lang=js"

import "./CoprarConvert.vue?vue&type=style&index=0&id=6dececa8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6dececa8"]])

export default __exports__